///<reference path='../typings/index.d.ts' />

"use strict"

module agi.expressions {
    export type AudioData = {
        trackData:any;
        trackInstance:HTMLAudioElement;
        loop:boolean;
        debug:boolean;
        extraBuffer:number;
        endTrackCallback:(event:Event)=>{};
    }

    export type AudioTrackDebugData = {
        currentTime:number;
        readyState:number;
        canPlay:boolean;
        stalled:boolean;
        seeking:boolean;
        waiting:boolean;
        paused:boolean;
        src:string;
        currentTrack:string;
        trackStartTime:number;
        trackEndTime:number;
        updated:boolean;
    }

    export class AudioPlayer {
        public audioData:AudioData;
        public trackNames:Array<string> = [];
        public currentTrack:number;
        public currentTrackStart:number;
        public currentTrackEnd:number;
        public EXTRA_BUFFER:number = 0;
        public LOOP_TRACK:boolean = false;
        public DEBUG:boolean = false;
        public paused:boolean = false;
        protected endTrackCallbackHandler;
        protected timeUpdateHandlerReference;
        protected playNextTrack:boolean = false;


        constructor(data:AudioData){
            this.audioData = data;
            this.init();
        }

        protected init():void {
            if (this.audioData.trackData &&
                this.audioData.trackData.sprite){
                for (var key in this.audioData.trackData.sprite){
                    this.trackNames.push(key);
                }

                if (this.audioData.loop !== undefined){
                    this.LOOP_TRACK = this.audioData.loop;
                }

                if (this.audioData.extraBuffer !== undefined){
                    this.audioData.extraBuffer = this.audioData.extraBuffer;
                }

                if (this.audioData.endTrackCallback !== undefined){
                    this.endTrackCallbackHandler = this.audioData.endTrackCallback;
                }

                if (this.audioData.debug !== undefined) {
                    this.DEBUG = this.audioData.debug;
                }

                this.currentTrack = 0;
                this.currentTrackStart = this.getTrackStart(this.currentTrack);
                this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
                if (this.DEBUG){
                    this.createTrackDebugData();
                    this.addDebugDataToDom();
                }

                this.audioData.trackInstance.addEventListener(
                    "ended", (event)=>{this.handleTrackEnded(event)}
                )
                this.timeUpdateHandlerReference = (event)=>{this.timeUpdateHandler(event)};
                this.audioData.trackInstance.addEventListener(
                    "timeupdate", this.timeUpdateHandlerReference
                );
                this.audioData.trackInstance.addEventListener(
                    "seeking", (event)=>{this.seekingHandler(event)}
                );
                this.audioData.trackInstance.addEventListener(
                    "seeked", (event)=>{this.seekedHandler(event)}
                );
                this.audioData.trackInstance.addEventListener(
                    "loadeddata", (event)=>{this.loadedDataHandler(event)}
                );
                this.audioData.trackInstance.addEventListener(
                    "canplay", (event)=>{this.updateCanPlay(event)}
                )
                this.audioData.trackInstance.addEventListener(
                    "canplaythrough", (event)=>{this.updateCanPlay(event)}
                )
                this.audioData.trackInstance.addEventListener(
                    "stalled", (event)=>{this.stalledHandler(event)}
                )
                this.audioData.trackInstance.addEventListener(
                    "waiting", this.waitingHandler.bind(this)
                )
             }
        }

        public playTracks():void{
            this.currentTrack = 0;
            this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
            this.currentTrackStart = this.getTrackStart(this.currentTrack);
            this.audioData.trackInstance.currentTime = 0;
            this.audioData.trackInstance.play();
        }

        public nextTrack():void {
            this.audioData.trackInstance.pause();
            this.playNextTrack = true;
            if (this.currentTrack+1 < this.trackNames.length){
                this.currentTrack = this.currentTrack+1;
            }
            else {
                this.currentTrack = 0;
            }
            this.currentTrackStart = this.getTrackStart(this.currentTrack);
            this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
            this.audioData.trackInstance.currentTime =
                this.getTrackStart(this.currentTrack);
        }

        public restart():void {
            if (!this.paused){
                this.playTracks();
            }
            else {
                this.currentTrack = 0;
                this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
                this.currentTrackStart = this.getTrackStart(this.currentTrack);
                this.audioData.trackInstance.currentTime = 0;
            }
        }

        public stop():void {
            this.audioData.trackInstance.pause();
            this.currentTrack = 0;
            this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
            this.currentTrackStart = this.getTrackStart(this.currentTrack);
            this.audioData.trackInstance.currentTime = 0;
        }

        public pause():void {
            this.paused = true;
            this.audioData.trackInstance.pause();
        }

        public resume():void {
            this.paused = false;
            this.audioData.trackInstance.play();
        }

        protected getTrackStart(trackIndex:number):number{
            return this.audioData.trackData.sprite[
                    this.trackNames[trackIndex]][0] / 1000;
        }

        protected getTrackEnd(trackIndex:number):number{
            return (this.audioData.trackData.sprite[
                    this.trackNames[trackIndex]][1] +
                    this.audioData.trackData.sprite[
                        this.trackNames[trackIndex]][0]) / 1000;
        }

        protected getCurrentTrackName():string{
            return this.trackNames[this.currentTrack];
        }

        //Event Handlers
        protected updateCanPlay(event):void {
            if (this.DEBUG){
                this.trackDebugData.canPlay = true;
                this.updateDebugDataDisplay();
            }
        }

        protected handleTrackEnded(event):void {
            this.playTracks();
        }

        protected timeUpdateHandler(event):void {
            if (this.audioData.trackInstance.currentTime >=
                this.currentTrackEnd+this.EXTRA_BUFFER){
                if(!this.LOOP_TRACK){
                    if (this.currentTrack < this.trackNames.length-1){
                        this.currentTrack += 1;
                        this.currentTrackEnd = this.getTrackEnd(this.currentTrack);
                        this.currentTrackStart = this.getTrackStart(this.currentTrack);
                    }
                }
                else if (!this.audioData.trackInstance.seeking){
                    this.audioData.trackInstance.currentTime =
                        this.getTrackStart(this.currentTrack);
                }
                if (this.endTrackCallbackHandler !== undefined){
                    this.endTrackCallbackHandler();
                }
            }
            if (this.DEBUG){
                this.updateTrackDebugData();
                this.updateDebugDataDisplay();
            }
        }

        protected seekingHandler(event):void {
            if (this.DEBUG){
                this.updateTrackDebugData();
                this.updateDebugDataDisplay();
            }
        }

        protected seekedHandler(event):void {
            if (this.playNextTrack && !this.paused){
                this.audioData.trackInstance.play();
                this.playNextTrack = false;
            }
            if (this.DEBUG){
                this.updateTrackDebugData();
                this.updateDebugDataDisplay();
            }
        }

        protected stalledHandler(event):void {
            if (this.DEBUG){
                this.trackDebugData.stalled = true;
                this.updateDebugDataDisplay();
            }
        }

        protected waitingHandler(event):void {
            if (this.DEBUG){
                this.trackDebugData.waiting = true;
                this.updateDebugDataDisplay();
            }
        }

        protected loadedDataHandler(event):void {
             if (this.DEBUG){
                this.updateTrackDebugData();
                this.updateDebugDataDisplay();
            }
        }

        //DEBUG
        //Debug Dom Elements
        public trackDebugData:AudioTrackDebugData;
        protected audioDebugPlayerData:HTMLDivElement;
        protected currentTimeDom:HTMLParagraphElement;
        protected readyStateDom:HTMLParagraphElement;
        protected canPlayDom:HTMLParagraphElement;
        protected stalledDomElement:HTMLParagraphElement;
        protected seekingDomElement:HTMLParagraphElement;
        protected waitingDomElement:HTMLParagraphElement;
        protected pausedDomElement:HTMLParagraphElement;
        protected srcDomElement:HTMLParagraphElement;
        protected currentTrackDomElement:HTMLParagraphElement;
        protected trackStartTimeDomElement:HTMLParagraphElement;
        protected trackEndTimeDomElement:HTMLParagraphElement;
        protected readyStates:Array<string> = [
            "HAVE_NOTHING",
            "HAVE_METADATA",
            "HAVE_CURRENT_DATA",
            "HAVE_FUTURE_DATA",
            "HAVE_ENOUGH_DATA"
        ]

        protected createTrackDebugData():void {
            this.trackDebugData = <AudioTrackDebugData>{};
            this.trackDebugData.canPlay = false;
            this.trackDebugData.updated = false;
            this.updateTrackDebugData();
        }

        protected updateTrackDebugData():void {
            if (this.audioData.trackInstance){
                this.trackDebugData.stalled = false;
                this.trackDebugData.waiting = false;
                this.trackDebugData.paused =
                    this.audioData.trackInstance.paused;
                this.trackDebugData.currentTime =
                    this.audioData.trackInstance.currentTime;
                this.trackDebugData.readyState =
                    this.audioData.trackInstance.readyState;
                this.trackDebugData.seeking =
                    this.audioData.trackInstance.seeking;
                this.trackDebugData.src =
                    this.audioData.trackInstance.currentSrc;
                this.trackDebugData.currentTrack =
                    this.getCurrentTrackName();
                this.trackDebugData.trackStartTime =
                    this.getTrackStart(this.currentTrack);
                this.trackDebugData.trackEndTime =
                    this.getTrackEnd(this.currentTrack);
                this.trackDebugData.updated = true;
            }
        }

        protected addDebugDataToDom() {
            this.audioDebugPlayerData = document.createElement("div");
            this.currentTimeDom = document.createElement("p");
            this.currentTimeDom.innerHTML =
                "Current Time: " + this.trackDebugData.currentTime.toString();
            this.pausedDomElement = document.createElement("p");
            this.pausedDomElement.innerHTML =
                "Playing: " + (!this.trackDebugData.paused).toString();
            this.readyStateDom = document.createElement("p");
            this.readyStateDom.innerHTML =
                "Ready State: " + this.readyStates[this.trackDebugData.readyState];
            this.canPlayDom = document.createElement("p");
            this.canPlayDom.innerHTML =
                "Can Play?: " + this.trackDebugData.canPlay.toString();
            this.stalledDomElement = document.createElement("p");
            this.stalledDomElement.innerHTML =
                "Stalled: " + this.trackDebugData.stalled.toString();
            this.seekingDomElement = document.createElement("p");
            this.seekingDomElement.innerHTML =
                "Seeking: " + this.trackDebugData.seeking.toString();

            this.waitingDomElement = document.createElement("p");
            this.waitingDomElement.innerHTML =
                "Waiting: " + this.trackDebugData.waiting.toString();
            this.srcDomElement = document.createElement("p");
            this.srcDomElement.innerHTML =
                "Source: " + this.trackDebugData.src;
            this.currentTrackDomElement = document.createElement("p");
            this.currentTrackDomElement.innerHTML =
                "Track Name: " + this.trackDebugData.currentTrack;
            this.trackStartTimeDomElement = document.createElement("p");
            this.trackStartTimeDomElement.innerHTML =
                "Track Start Time: " + this.trackDebugData.trackStartTime.toString();
            this.trackEndTimeDomElement = document.createElement("p");
            this.trackEndTimeDomElement.innerHTML =
                "Track End Time: " + this.trackDebugData.trackEndTime.toString();

            this.audioDebugPlayerData.appendChild(this.srcDomElement);
            this.audioDebugPlayerData.appendChild(this.currentTrackDomElement);
            this.audioDebugPlayerData.appendChild(this.readyStateDom);
            this.audioDebugPlayerData.appendChild(this.canPlayDom);
            this.audioDebugPlayerData.appendChild(this.pausedDomElement);
            this.audioDebugPlayerData.appendChild(this.currentTimeDom);
            this.audioDebugPlayerData.appendChild(this.trackStartTimeDomElement);
            this.audioDebugPlayerData.appendChild(this.trackEndTimeDomElement);
            this.audioDebugPlayerData.appendChild(this.seekingDomElement);
            this.audioDebugPlayerData.appendChild(this.waitingDomElement);
            this.audioDebugPlayerData.appendChild(this.stalledDomElement);

            //styles
            this.audioDebugPlayerData.style.backgroundColor = "rgba(88,88,88,0.5)";
            this.audioDebugPlayerData.style.position = "fixed";
            this.audioDebugPlayerData.style.zIndex = "400";
            this.audioDebugPlayerData.style.fontFamily = "monospace";
            this.audioDebugPlayerData.style.color = "white";
            this.audioDebugPlayerData.style.width = "150px";
            this.audioDebugPlayerData.style.fontSize = "8px";
            this.audioDebugPlayerData.style.wordWrap = "break-word";

            document.body.appendChild(this.audioDebugPlayerData);
        }

        protected updateDebugDataDisplay():void {
            this.currentTimeDom.innerHTML =
                "Current Time: " + this.trackDebugData.currentTime.toString();
            this.pausedDomElement.innerHTML =
                "Playing: " + (!this.trackDebugData.paused).toString();
            this.readyStateDom.innerHTML =
                "Ready State: " + this.readyStates[this.trackDebugData.readyState];
            this.canPlayDom.innerHTML =
                "Can Play?: " + this.trackDebugData.canPlay.toString();
            this.stalledDomElement.innerHTML =
                "Stalled: " + this.trackDebugData.stalled.toString();
            this.seekingDomElement.innerHTML =
                "Seeking: " + this.trackDebugData.seeking.toString();
            this.waitingDomElement.innerHTML =
                "Waiting: " + this.trackDebugData.waiting.toString();
            this.srcDomElement.innerHTML =
                "Source: " + this.trackDebugData.src;
            this.currentTrackDomElement.innerHTML =
                "Track Name: " + this.trackDebugData.currentTrack;
            this.trackStartTimeDomElement.innerHTML =
                "Track Start Time: " + this.trackDebugData.trackStartTime.toString();
            this.trackEndTimeDomElement.innerHTML =
                "Track End Time: " + this.trackDebugData.trackEndTime.toString();
        }
    }
}
